import { Heading } from '@components/_rcpo/ui/Heading'
import { useTranslation } from 'next-i18next'
import React, { FC } from 'react'
import { RCPO_ATTRIBUTE_ID_COLLECTION, RCPOFilter } from '../hooks/use-rcpo-data'
import { FilterGroup } from './FilterGroup'

type FilterGroupsProps = {
  filters: RCPOFilter[]
}

export const FilterGroups: FC<FilterGroupsProps> = ({ filters }) => {
  const { t } = useTranslation('rolex')
  const collectionFilter = filters.find(
    (filter) => filter.attributeID === RCPO_ATTRIBUTE_ID_COLLECTION,
  )
  const otherFilters = filters.filter(
    (filter) => filter.attributeID !== RCPO_ATTRIBUTE_ID_COLLECTION,
  )

  return (
    <>
      {collectionFilter && (
        <div className="break-inside-avoid-column">
          <Heading variant="small-title" className="mb-5">
            {t(`filters.title81`)}
          </Heading>
          <FilterGroup {...collectionFilter} attributeValuePrefix={'Rolex'} />
        </div>
      )}
      {otherFilters &&
        otherFilters.map((filter) => (
          <div key={filter.attributeID} className="break-inside-avoid-column">
            <Heading variant="small-title" className="mb-5">
              {t(`filters.title${filter.attributeID}`)}
            </Heading>
            <FilterGroup {...filter} />
          </div>
        ))}
    </>
  )
}
